module.exports = __webpack_public_path__ + "static/media/login-image.b7d9c808.jpg";